import { useLocation } from 'react-router-dom';

const VRTour = () => {
    const location = useLocation();
    const { customUrl2, vrPath } = location.state || { customUrl2: '', vrPath: '' };
    console.log(customUrl2)
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`/VR 360/${customUrl2}/360/${vrPath}/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR Tour"
        ></iframe>
      </div>
    );
};

export default VRTour;
